<template>
    <div>
        <b-row>
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">
                            REGISTRO DE PAGAMENTO GESCON
                            <b-badge variant="warning">{{ operacao }}</b-badge>
                        </span>
                    </b-card-header>
                    <b-card-body>
                        <b-row>
                            <b-col sm="12">
                                <app-k-v
                                    titulo="Protocolo"
                                    :md="md"
                                    :lg="lg"
                                    :xl="xl"
                                    >{{ pagamento.protocolo }}
                                    <app-status
                                        v-if="pagamento.prioritario"
                                        status="PRIORITÁRIO"
                                    ></app-status>
                                    <app-status
                                        class="ml-1"
                                        v-if="pagamento.especial"
                                        status="ESPECIAL"
                                    ></app-status
                                ></app-k-v>
                                <app-k-v
                                    titulo="Fornecedor"
                                    :md="md"
                                    :lg="lg"
                                    :xl="xl"
                                    :dado="pagamento.fornecedor"
                                ></app-k-v>
                                <app-k-v
                                    titulo="Contrato"
                                    :md="md"
                                    :lg="lg"
                                    :xl="xl"
                                    :dado="pagamento.contrato"
                                ></app-k-v>
                                <app-k-v
                                    titulo="Qtd. Comprometimentos"
                                    :md="md"
                                    :lg="lg"
                                    :xl="xl"
                                    ><strong>{{
                                        pagamento.qtdComprometimentos
                                    }}</strong></app-k-v
                                >
                                <app-k-v
                                    titulo="Qtd. Anexos"
                                    :md="md"
                                    :lg="lg"
                                    :xl="xl"
                                    ><strong>{{
                                        pagamento.qtdAnexos
                                    }}</strong></app-k-v
                                >
                                <app-k-v
                                    titulo="Valor Total"
                                    :md="md"
                                    :lg="lg"
                                    :xl="xl"
                                    ><strong>{{
                                        pagamento.valorTotal | currency
                                    }}</strong></app-k-v
                                >
                                <app-k-v
                                    titulo="Observações"
                                    :md="md"
                                    :lg="lg"
                                    :xl="xl"
                                    ><strong>{{
                                        pagamento.observacoes
                                    }}</strong>
                                    <pagamento-observacoes
                                        :pagamento="pagamento"
                                        :pagamentosServicos="pagamentosServicos"
                                        @obterPagamentoAtualizado="
                                            $emit('obterPagamentoAtualizado')
                                        "
                                    ></pagamento-observacoes
                                ></app-k-v>
                                <app-k-v
                                    titulo="Status"
                                    :md="md"
                                    :lg="lg"
                                    :xl="xl"
                                    ><app-status
                                        :status="
                                            pagamento.statusDescr
                                                ? pagamento.statusDescr
                                                : ''
                                        "
                                    ></app-status>
                                    <pagamento-detalhe-reprovacao
                                        :pagamento="pagamento"
                                    ></pagamento-detalhe-reprovacao>
                                    <pagamento-detalhe-aprovacao-justificada
                                        :pagamento="pagamento"
                                    ></pagamento-detalhe-aprovacao-justificada>
                                </app-k-v>
                                <app-k-v
                                    titulo="Última Atualização"
                                    :md="md"
                                    :lg="lg"
                                    :xl="xl"
                                    ><strong>{{
                                        pagamento.dataAtualizacao
                                            ? $moment(
                                                  pagamento.dataAtualizacao
                                              ).format('DD/MM/YYYY HH:mm')
                                            : ''
                                    }}</strong></app-k-v
                                >
                            </b-col>
                        </b-row>
                        <slot name="mensagem"></slot>
                    </b-card-body>
                    <b-card-footer>
                        <slot name="footer" v-bind="pagamento"></slot>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import PagamentoDetalheReprovacao from './PagamentoDetalheReprovacao'
import PagamentoObservacoes from './PagamentoObservacoes'
import PagamentoDetalheAprovacaoJustificada from './PagamentoDetalheAprovacaoJustificada.vue';

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            operacao: 'DETALHAR',
            xl: 2,
            lg: 2,
            md: 3
        }
    },

    components: {
        PagamentoDetalheReprovacao,
        PagamentoObservacoes,
        PagamentoDetalheAprovacaoJustificada
    }
}
</script>
